import axios from "axios";
import toast from "react-hot-toast";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

// Action Types
export const FETCH_DASHBOARD_STATS_REQUEST = "FETCH_DASHBOARD_STATS_REQUEST";
export const FETCH_DASHBOARD_STATS_SUCCESS = "FETCH_DASHBOARD_STATS_SUCCESS";
export const FETCH_DASHBOARD_STATS_FAILURE = "FETCH_DASHBOARD_STATS_FAILURE";

export const FETCH_CHALLAN_STATS_REQUEST = "FETCH_CHALLAN_STATS_REQUEST";
export const FETCH_CHALLAN_STATS_SUCCESS = "FETCH_CHALLAN_STATS_SUCCESS";
export const FETCH_CHALLAN_STATS_FAILURE = "FETCH_CHALLAN_STATS_FAILURE";

export const FETCH_OFFICER_STATS_REQUEST = "FETCH_OFFICER_STATS_REQUEST";
export const FETCH_OFFICER_STATS_SUCCESS = "FETCH_OFFICER_STATS_SUCCESS";
export const FETCH_OFFICER_STATS_FAILURE = "FETCH_OFFICER_STATS_FAILURE";

export const FETCH_CHART_DATA_REQUEST = "FETCH_CHART_DATA_REQUEST";
export const FETCH_CHART_DATA_SUCCESS = "FETCH_CHART_DATA_SUCCESS";
export const FETCH_CHART_DATA_FAILURE = "FETCH_CHART_DATA_FAILURE";

// Fetch Dashboard Stats
export const fetchDashboardStats = () => async (dispatch) => {
  dispatch({ type: FETCH_DASHBOARD_STATS_REQUEST });
  const token = localStorage.getItem("token");

  try {
    const response = await axios.get(
      `${BASE_URL}/v1/api/admin/dashboard/stats`,
      { headers: { authorization: token } },
    );

    if (response.data.meta.status) {
      dispatch({
        type: FETCH_DASHBOARD_STATS_SUCCESS,
        payload: response.data.data,
      });
      return response.data;
    } else {
      dispatch({ type: FETCH_DASHBOARD_STATS_FAILURE });
      throw new Error(response.data.meta.message);
    }
  } catch (error) {
    dispatch({ type: FETCH_DASHBOARD_STATS_FAILURE });
    toast.error(
      error.response?.data?.meta?.message || "Failed to fetch dashboard stats",
    );
    throw error;
  }
};

// Fetch Chart Data
export const fetchChartData =
  (districtId = null, municipalityId = null) =>
  async (dispatch) => {
    dispatch({ type: FETCH_CHART_DATA_REQUEST });
    const token = localStorage.getItem("token");

    try {
      let url = `${BASE_URL}/v1/api/admin/dashboard/charts`;
      const params = new URLSearchParams();
      if (districtId) params.append("district_id", districtId);
      if (municipalityId) params.append("municipality_id", municipalityId);
      if (params.toString()) url += `?${params.toString()}`;

      const response = await axios.get(url, {
        headers: { authorization: token },
      });

      if (response.data.meta.status) {
        dispatch({
          type: FETCH_CHART_DATA_SUCCESS,
          payload: response.data.data,
        });
        return response.data;
      } else {
        dispatch({ type: FETCH_CHART_DATA_FAILURE });
        throw new Error(response.data.meta.message);
      }
    } catch (error) {
      dispatch({ type: FETCH_CHART_DATA_FAILURE });
      toast.error(
        error.response?.data?.meta?.message || "Failed to fetch chart data",
      );
      throw error;
    }
  };
// Fetch Challan Stats
export const fetchChallanStats =
  (districtId = null, municipalityId = null) =>
  async (dispatch) => {
    dispatch({ type: FETCH_CHALLAN_STATS_REQUEST });
    const token = localStorage.getItem("token");

    try {
      let url = `${BASE_URL}/v1/api/admin/dashboard/challan-stats`;
      const params = new URLSearchParams();
      if (districtId) params.append("district_id", districtId);
      if (municipalityId) params.append("municipality_id", municipalityId);
      if (params.toString()) url += `?${params.toString()}`;

      const response = await axios.get(url, {
        headers: { authorization: token },
      });

      if (response.data.meta.status) {
        dispatch({
          type: FETCH_CHALLAN_STATS_SUCCESS,
          payload: response.data.data || [],
        });
        return response.data;
      } else {
        dispatch({ type: FETCH_CHALLAN_STATS_FAILURE });
        throw new Error(response.data.meta.message);
      }
    } catch (error) {
      dispatch({ type: FETCH_CHALLAN_STATS_FAILURE });
      toast.error(
        error.response?.data?.meta?.message || "Failed to fetch challan stats",
      );
      throw error;
    }
  };

// Fetch Officer Stats
export const fetchOfficerStats =
  (districtId = null, municipalityId = null) =>
  async (dispatch) => {
    dispatch({ type: FETCH_OFFICER_STATS_REQUEST });
    const token = localStorage.getItem("token");

    try {
      let url = `${BASE_URL}/v1/api/admin/dashboard/officer-stats`;
      const params = new URLSearchParams();
      if (districtId) params.append("district_id", districtId);
      if (municipalityId) params.append("municipality_id", municipalityId);
      if (params.toString()) url += `?${params.toString()}`;

      const response = await axios.get(url, {
        headers: { authorization: token },
      });

      if (response.data.meta.status) {
        dispatch({
          type: FETCH_OFFICER_STATS_SUCCESS,
          payload: response.data.data || [],
        });
        return response.data;
      } else {
        dispatch({ type: FETCH_OFFICER_STATS_FAILURE });
        throw new Error(response.data.meta.message);
      }
    } catch (error) {
      dispatch({ type: FETCH_OFFICER_STATS_FAILURE });
      toast.error(
        error.response?.data?.meta?.message || "Failed to fetch officer stats",
      );
      throw error;
    }
  };
